<template>
  <div class="row mx-3">
    <label class="form-label p-0 size-12 lh-12">雇用形態</label>
    <div class="row justify-content-start w-77">
      <Field name="employment_type_id">
        <div
          v-for="employment in props.employmentTypes"
          :key="employment.id"
          class="col-auto me-2 my-2 py-2 align-items-center bg-silver-primary rounded-2 d-flex align-items-center"
        >
          <input
            :id="employment.id.toString()"
            class="form-check-input form-check-base w-1d5 h-1d5 radio-primary-input mt-0"
            type="checkbox"
            :checked="props.employments.some((item) => item.id == employment.id)"
            @change="selectEmployment(employment)"
          />
          <label
            class="form-check-label form-check-label-base size-12 ms-3"
            :for="employment.id.toString()"
          >
            {{ employment?.name ?? '' }}
          </label>
        </div>
      </Field>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EmploymentTypePrimary } from '@/types/models/employmentType';
import { Field } from 'vee-validate';
import { PropType } from 'vue';

const selectEmployment = (employment: EmploymentTypePrimary): void => {
  emit('select', employment);
};

const props = defineProps({
  employments: {
    type: Array as PropType<Array<EmploymentTypePrimary>>,
    required: false,
    default: () => [],
  },
  employmentTypes: {
    type: Array as unknown as () => any,
    required: false,
  },
});

const emit = defineEmits(['select']);
</script>
